module.exports = __webpack_public_path__ + "225d27daa435181537351b18f1dfdd04.eot";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/GT-Walsheim-Pro-Light.eot
// module id = 404
// module chunks = 0